import { render, staticRenderFns } from "./StackWeight.vue?vue&type=template&id=0fab8b4d&scoped=true"
import script from "./StackWeight.vue?vue&type=script&lang=ts"
export * from "./StackWeight.vue?vue&type=script&lang=ts"
import style0 from "./StackWeight.vue?vue&type=style&index=0&id=0fab8b4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fab8b4d",
  null
  
)

export default component.exports